import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

import { AdfoxTapTarget, isBrowserTapAllowed } from 'components/Admin/AdfoxInfo/adfoxInfoModel';
import { RadioGroup } from 'components/Admin/AdfoxInfo/RadioGroup/RadioGroup';
import { HintIcon } from 'components/Admin/AdfoxInfo/TapTargetSelect/HintIcon/HintIcon';

import { updateAdfoxInfoForm } from 'store/models/adfoxInfo';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'admin.adfoxInfo.tapTarget.title',
    tapTarget: {
        [AdfoxTapTarget.InApp]: 'admin.adfoxInfo.tapTarget.inApp',
        [AdfoxTapTarget.Browser]: 'admin.adfoxInfo.tapTarget.browser',
    },
    hint: 'admin.adfoxInfo.tapTarget.hint',
    shiftsHint: 'admin.adfoxInfo.tapTarget.shiftsHint',
};

export const TapTargetSelect: FC = () => {
    const placement = useSelector((state) => state.adfoxInfo.placement);
    const value = useSelector((state) => state.adfoxInfo.tapTarget);

    const trls = useTrls();
    const dispatch = useDispatch();
    const isBrowserAllowed = isBrowserTapAllowed(placement);

    return (
        <RadioGroup
            title={trls(TrlKeys.title)}
            name="adfox-info-tap-target"
            options={isBrowserAllowed ? [AdfoxTapTarget.InApp, AdfoxTapTarget.Browser] : [AdfoxTapTarget.InApp]}
            value={value}
            labels={TrlKeys.tapTarget}
            dataQaPrefix="adfox-info-tap-target"
            renderHint={(option) =>
                option === AdfoxTapTarget.InApp ? (
                    <HintIcon
                        text={trls(isBrowserAllowed ? TrlKeys.hint : TrlKeys.shiftsHint)}
                        dataQa="adfox-info-tap-target-hint"
                    />
                ) : null
            }
            onChange={(tapTarget) => dispatch(updateAdfoxInfoForm({ tapTarget }))}
        />
    );
};
